import React from 'react';
import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import {useNavigate, useParams} from "react-router-dom";
import Header from "../../Layouts/Header";
import Navbar from "../../Layouts/Navbar";
import {AiOutlineAppstoreAdd} from "react-icons/ai";
import {HiOutlineQrcode} from "react-icons/hi";
import {TbBuildingStore, TbStatusChange} from "react-icons/tb";
import {BsCalendar2Check, BsCalendar4Week, BsInfoSquare} from "react-icons/bs";
import {PiTruckThin} from "react-icons/pi";
import {LiaEyeSolid} from "react-icons/lia";
import {MapContainer, Marker, Popup, TileLayer} from 'react-leaflet'
import 'leaflet/dist/leaflet.css';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import L from 'leaflet';
import {IoMdCheckmarkCircleOutline} from "react-icons/io";
let DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow
});
L.Marker.prototype.options.icon = DefaultIcon;


function OrderDetails() {
    const navigate = useNavigate();

    const {id} = useParams();
    const [isLoaded, setIsLoaded] = React.useState(false);
    const [readOnlyStatus, setReadOnlyStatus] = React.useState(true);
    const [factorNumber, setFactorNumber] = React.useState('');
    const [battery_qty, setQty] = React.useState(0);
    const [batteryDescription, setBatteryDescription] = React.useState('');
    const [ampType, setAmpType] = React.useState('');
    const [batteryType, setBatteryType] = React.useState('');
    const [brand, setBrand] = React.useState('');
    const [battery_qty1, setQty1] = React.useState('');
    const [isEdit, setIsEdit] = React.useState(false);
    const [batteryQtyDetails, setQtyDetails] = React.useState([]);
    const [pDescription, setPDescription] = React.useState('');
    const [description, setDescription] = React.useState('');
    const [orderDescription, setOrderDescription] = React.useState('');
    const [order, setOrder] = React.useState([]);
    const [basics, setBasics] = React.useState([]);
    const [documentFile, setDocumentFile] = React.useState(null);
    const [documentTitle, setDocumentTitle] = React.useState('');
    const [factor, setFactor] = React.useState([]);



    React.useEffect(() => {

        const params = {
            'processFor' : 'Sales',

        }

        API.getOrder(params , id)
            .then((response) => {
                setOrder(response.data);
                let descriptions = response.data.public_description;
                descriptions = descriptions?.replaceAll('***' , '<br/> - ');
                setOrderDescription(descriptions)
                setFactorNumber(response.data.factor_number);
                setPDescription(response.data.private_description);
                setQty(response.data.battery_qty);
                setQtyDetails(response.data.battery_qty_detail_vendor);
                setFactor(response.data.battery_qty_detail);

                API.getBasics(params)
                    .then((response) => {
                        setBasics(response.data)
                        setIsLoaded(true)
                    })
                    .catch((error) => {

                    });

                if(response.data.last_status.id === 1 ||response.data.last_status.id === 13 ||response.data.last_status.id === 17  ) {
                    setReadOnlyStatus(false)
                }
            })
            .catch((error) => {

                if(error.response) {
                    toast.error(error.response.data.message);
                    setTimeout (() => {
                         // window.history.back()
                    },400)
                }
                else {
                    toast.error(error.message);
                    setTimeout (() => {
                       // window.history.back()
                    },400)
                }
            });


    }, [id]);

    const onUpdateQtyDetails = () => {
        let cartItems = factor;
        let count = parseInt(battery_qty1);

        let totalCount = parseInt(battery_qty);
        if (cartItems) {
            const find_item = cartItems.find(x => (x.brand === brand && x.amperage === ampType))
            if (find_item) {
                const objIndex = cartItems.findIndex(x => (x.brand === brand && x.amperage === ampType))
                if (isEdit && count === 0) {
                    totalCount = totalCount - find_item.count;
                    cartItems.splice(objIndex, 1)
                } else {
                    if (!isEdit) {
                        totalCount = totalCount + parseInt(count);
                        count += parseInt(find_item.count);
                    }
                    else{
                        totalCount = totalCount - cartItems[objIndex].count;
                        totalCount = totalCount + parseInt(count);
                    }

                    cartItems[objIndex].count = count;
                    cartItems[objIndex].brand = brand;
                    cartItems[objIndex].batteryType = batteryType;
                    cartItems[objIndex].batteryDescription = batteryDescription;

                }

            } else {
                if (count > 0) {
                    totalCount = totalCount + parseInt(count);
                    cartItems.push({ brand, 'amperage': ampType,  count , batteryType, batteryDescription})
                } else {
                    toast.warning('حداقل تعداد وارد شده 1 می باشد')
                    return false
                }

            }
        }
        if (!cartItems) { //Object.keys(this.state.markets).length < 1
            if (count > 0) {
                totalCount = totalCount + parseInt(count);
                cartItems = [];
                cartItems.push({ brand, 'amperage': ampType,  count , batteryType, batteryDescription})
            } else {
                toast.warning('حداقل تعداد وارد شده 1 می باشد')
                return false
            }
        }

        setFactor(cartItems);
        setAmpType('')
        setBrand('')
        setQty1('')
        setBatteryType('')
        setBatteryDescription('')
        setIsEdit(false)
        setQty(totalCount)
    }

    const onButtonClick = () => {

        const request = {
            id,
            factor_number: factorNumber,
            battery_qty,
            battery_qty_detail: factor,
            public_description: description,
            private_description: pDescription,
        }

        setIsLoaded(false);
        API.editOrder(request,id)
            .then((response) => {
                toast.success(response.message);
                setIsLoaded(true);
            })
            .catch((error) => {
                setIsLoaded(true);
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });

    }

    const onStatusButtonClick =  (statusId) => {
        setIsLoaded(false);
        const request = {
            order_id: id,
            status_id : statusId,
            'processFor' : 'Sales',
        }
        API.updateStatus( request )
            .then((response) => {
                toast.success(response.message);
                window.location.reload()
            })
            .catch((error) => {
                toast.error(error.response.data.message)
                setIsLoaded(true);
            });
    }

    const onDocChange = (event) => {
        setDocumentFile(event.target.files[0])
    }

    const onUploadClick = () => {
        const formData = new FormData();
        const file = documentFile;

        if (file) {
            if(file.size > 10485760) {
                toast.error('حجم فایل ارسالی نمی تواند بیشتر از ۱۰ مگابایت باشد');
                return false;
            }
            formData.append('document_file', file);
            if (!documentTitle) {
                toast.error('لطفا عنوان فایل ارسالی را مشخص کنید');
                return false;
            }
        } else {
            toast.error('لطفا ابتدا یک فایل معتبر انتخاب کنید!');
            return false;
        }

        formData.append('document_title',  documentTitle);

        formData.append('id', id);

        API.uploadFile(formData)
            .then((response) => {
                toast.success(response.message);
                window.location.reload()
            })
            .catch((error) => {
                toast.error(error.response.data.message)
            });
    }


    return (
        <React.Fragment>
            <Header/>

            <Navbar page="orders" public="1"/>
            <Toast/>
            {
                !isLoaded && <Loading/>
            }
            <main id="main" className="main rtl">

                <div className="pagetitle mb-5 border-bottom pb-4">
                    <h1>
                        <AiOutlineAppstoreAdd className='ms-2'/>
                        مدیریت سفارش
                    </h1>

                </div>

                <section className="section">
                    <div className="row">
                        <div className="col-lg-12">

                            <div className="card">
                                <div className="card-body">
                                    <div className="row mx-2 mb-3 border-bottom pb-2 pt-5">
                                        <div className="col-1">
                                            <TbBuildingStore />
                                        </div>
                                        <div className="col-5 text-small-2">
                                            نماینده:
                                        </div>
                                        <div className="col-6 text-start fw-bold text-small-2">
                                            {order?.vendor?.title}
                                            &nbsp;
                                            (
                                            {order?.vendor?.city}
                                            )
                                            {
                                                order?.vendor?.is_tropical ?
                                                    <span className='badge text-bg-warning mx-2 p-2'> گرمسیری</span>
                                                    : ""
                                            }
                                        </div>
                                    </div>
                                    <div className="row mx-2 mb-3 border-bottom pb-2">
                                        <div className="col-1">
                                            <HiOutlineQrcode />
                                        </div>
                                        <div className="col-5 text-small-2">
                                            کد سفارش:
                                        </div>
                                        <div className="col-6 text-start fw-bold text-small-2">
                                            {order.tracking_code}
                                        </div>
                                    </div>
                                    <div className="row mx-2 mb-3 border-bottom pb-2">
                                        <div className="col-1">
                                            <TbStatusChange />
                                        </div>
                                        <div className="col-5 text-small-2">
                                            وضعیت سفارش
                                        </div>
                                        <div className="col-6 text-start fw-bold text-small-2" style={{color: order?.last_status?.color}}>
                                            {order?.last_status?.title}
                                        </div>


                                    </div>
                                    <div className="row mx-2 mb-3 pb-2 border-bottom">
                                        <div className="col-1">
                                            <BsCalendar4Week />
                                        </div>
                                        <div className="col-4 text-small-2">
                                            تاریخ ثبت
                                        </div>
                                        <div className="col-7 text-start fw-bold text-small-2">
                                            {order.date}
                                        </div>
                                    </div>
                                    <div className="row mx-2 mb-3 pb-2 border-bottom">
                                        <div className="col-1">
                                            <BsInfoSquare />
                                        </div>
                                        <div className="col-11 text-small-2">
                                            توضیحات سفارش
                                        </div>
                                        <div className="col-2 text-small-2">
                                           &nbsp;
                                        </div>
                                        <div className="col-10 text-end fw-bold text-small-2">

                                            <div className="content" dangerouslySetInnerHTML={{__html: orderDescription}}></div>

                                        </div>
                                    </div>
                                    <div className="row mx-2 mb-3 pb-2 border-bottom">
                                        <div className="col-1">
                                            <PiTruckThin />
                                        </div>
                                        <div className="col-11 text-small-2">
                                           مشخصات راننده
                                        </div>
                                        <div className="col-2 text-small-2">
                                           &nbsp;
                                        </div>
                                        <div className="col-10 text-end fw-bold text-small-2">

                                            {order.driver_info}

                                        </div>
                                    </div>
                                    <div className="row mx-2 mb-3 pb-2 border-bottom">
                                        <div className="col-1">
                                            <BsCalendar2Check />
                                        </div>
                                        <div className="col-4 text-small-2">
                                            تاریخ مورد نظر برای تحویل
                                        </div>
                                        <div className="col-7 text-start fw-bold text-small-2">
                                            {order.vendor_suggest_date}
                                        </div>
                                    </div>
                                    <div className="col-12 mt-1">
                                        <div className=" ">
                                            <div className="card-header text-end text-small-2">
                                                 باتری های درخواستی نماینده
                                                &nbsp;

                                            </div>

                                            <div className="text-body-secondary text-small-1">
                                                {
                                                    batteryQtyDetails?.length > 0 &&
                                                    <table className="table  text-small-2">
                                                        <thead className='text-center'>
                                                        <tr>
                                                            <th scope="col">#</th>
                                                            <th scope="col">برند</th>
                                                            <th scope="col">آمپراژ</th>
                                                            <th scope="col">نوع</th>
                                                            <th scope="col">تعداد</th>
                                                            <th scope="col">توضیحات</th>

                                                        </tr>
                                                        </thead>
                                                        <tbody className='text-center'>
                                                        {
                                                            batteryQtyDetails?.map((cart, index) => {
                                                                return (
                                                                    <tr key={index}>
                                                                        <th scope="row">{index + 1}</th>
                                                                        <td>{cart.brand}</td>
                                                                        <td>{cart.amperage}</td>
                                                                        <td>{cart.batteryType}</td>
                                                                        <td>{cart.count}</td>
                                                                        <td>{cart.batteryDescription}</td>

                                                                    </tr>
                                                                )
                                                            })
                                                        }
                                                        </tbody>
                                                    </table>
                                                }

                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mx-2 mt-2">


                                        <div className="form-floating col-md-6 mt-4">
                                            <input type="text"
                                                   className="form-control px-5 text-left"
                                                   id="username" name="username"
                                                   placeholder="شماره "
                                                   value={factorNumber}
                                                   readOnly={readOnlyStatus}
                                                   onChange={
                                                       (ev) => {
                                                           setFactorNumber(ev.target.value)
                                                       }
                                                   }

                                            />
                                            <label htmlFor="mobile" className="right-0">شماره فاکتور سیستم
                                                حسابداری</label>
                                        </div>
                                        <div className="form-floating col-md-6 mt-4">
                                            <input type="number"
                                                   className="form-control px-5 text-left"
                                                   id="username" name="username"
                                                   placeholder="تعداد "
                                                   value={battery_qty}
                                                   disabled={true}

                                            />
                                            <label htmlFor="mobile" className="right-0">
                                                تعداد  کل باتری سفارش
                                            </label>
                                        </div>

                                        <div className="col-12 mt-4">
                                            <div className="card ">
                                                <div className="card-header text-end text-small-2">
                                                    لیست باتری های سفارش
                                                </div>
                                                {
                                                    (order?.last_status?.id === 1  || order?.last_status?.id === 13 || order?.last_status?.id === 17 )   &&
                                                <div className="card-body text-small-2">

                                                    <div className="row p-3">

                                                        <div className="col-md-4 mb-2">

                                                            <select
                                                                className="form-control text-center text-small-1"
                                                                id="floatingInput"
                                                                disabled={isEdit}
                                                                value={brand}
                                                                onChange={
                                                                    (event) => {
                                                                        setBrand(event.target.value)
                                                                    }
                                                                }
                                                            >
                                                                <option value="0">
                                                                    انتخاب برند
                                                                </option>
                                                                {
                                                                    basics?.brands?.map(bt => {
                                                                        return (
                                                                            <option value={bt.name} key={bt.id}>
                                                                                {bt.name}
                                                                            </option>
                                                                        )
                                                                    })
                                                                }
                                                            </select>
                                                        </div>
                                                        <div className="col-md-4 mb-2">

                                                            <select
                                                                className="form-control text-center text-small-1"
                                                                id="floatingInput"
                                                                disabled={isEdit}
                                                                value={ampType}
                                                                onChange={
                                                                    (event) => {
                                                                        setAmpType(event.target.value)
                                                                    }
                                                                }
                                                            >
                                                                <option value="0">
                                                                    انتخاب آمپراژ
                                                                </option>
                                                                {
                                                                    basics?.amperages?.map(bt => {
                                                                        return (
                                                                            <option value={bt.title} key={bt.title}>
                                                                                {bt.title}
                                                                            </option>
                                                                        )
                                                                    })
                                                                }
                                                            </select>
                                                        </div>
                                                        <div className="col-md-4 mb-2">
                                                            <select
                                                                className="form-control text-center text-small-1"
                                                                id="floatingInput"

                                                                value={batteryType}
                                                                onChange={
                                                                    (event) => {
                                                                        setBatteryType(event.target.value)
                                                                    }
                                                                }
                                                            >
                                                                <option value="0">
                                                                    انتخاب نوع باتری
                                                                </option>
                                                                <option value='سبک'>
                                                                    سبک
                                                                </option>

                                                                <option value='سنگین'>
                                                                    سنگین
                                                                </option>
                                                                <option value='موتورسیکلت'>
                                                                    موتورسیکلت
                                                                </option>
                                                                <option value='VRLA'>
                                                                    VRLA
                                                                </option>
                                                                <option value='VRLA-M'>
                                                                    VRLA Medium
                                                                </option>
                                                                <option value='VRLA-L'>
                                                                    VRLA Large
                                                                </option>
                                                                <option value='AGM'>
                                                                    AGM
                                                                </option>
                                                                <option value='EFB'>
                                                                    EFB
                                                                </option>
                                                            </select>
                                                        </div>
                                                        <div className="col-md-8 mb-2">
                                                        <div className="mb-3">

                                                                <input type="text"
                                                                       className="form-control text-center text-small-1"
                                                                       placeholder="توضیحات"
                                                                       value={batteryDescription}
                                                                       onChange={
                                                                           (val) => {
                                                                               setBatteryDescription(val.target.value)
                                                                           }
                                                                       }

                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4 mb-2">
                                                            <div className="mb-3">

                                                                <input type="number"
                                                                       className="form-control text-center text-small-1 border-black"
                                                                       placeholder="تعداد مورد درخواست"
                                                                       value={battery_qty1}
                                                                       onChange={
                                                                           (val) => {
                                                                               setQty1(val.target.value)
                                                                           }
                                                                       }

                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 text-center text-warning text-small-1 pt-3">
                                                           برای نهایی شدن تغییرات حتما دکمه ویرایش سفارش را بزنید
                                                        </div>
                                                        <div className="col-md-6">
                                                            <button
                                                                className="btn  w-100 btn-primary   text-small-1 mt-3"
                                                                onClick={onUpdateQtyDetails}
                                                            >افزودن به سفارش
                                                            </button>
                                                        </div>
                                                    </div>

                                                </div>
                                                }
                                                <div className="card-footer text-body-secondary">
                                                    <div className='mb-4'>
                                                 <span className='alert alert-primary fade show text-small-2 py-1' role='button'
                                                       onClick={() => navigate(`/order-batteries/${id}`)}
                                                 >
                                                گزارش وضعیت باتری های این سفارش
                                                     &nbsp;
                                                     <LiaEyeSolid />
                                            </span>
                                                    </div>
                                                    <div className="card-footer text-body-secondary">
                                                        {
                                                            factor?.length > 0 &&
                                                            <table className="table table-striped text-small-2">
                                                                <thead className='text-center'>
                                                                <tr>
                                                                    <th scope="col">#</th>
                                                                    <th scope="col">برند</th>
                                                                    <th scope="col">آمپراژ</th>
                                                                    <th scope="col">نوع</th>
                                                                    <th scope="col">تعداد</th>
                                                                    <th scope="col">توضیحات</th>
                                                                    <th scope="col">عملیات</th>
                                                                </tr>
                                                                </thead>
                                                                <tbody className='text-center'>
                                                                {
                                                                    factor?.map((cart, index) => {
                                                                        return (
                                                                            <tr key={index}>
                                                                                <th scope="row">{index + 1}</th>
                                                                                <td>{cart.brand}</td>
                                                                                <td>{cart.amperage}</td>
                                                                                <td>{cart.batteryType}</td>
                                                                                <td>{cart.count}</td>
                                                                                <td>{cart.batteryDescription}</td>
                                                                                <td>
                                                                                    <button type="button" className="btn btn-info text-small-3 mx-2"
                                                                                            onClick={() => {

                                                                                                setBrand(cart.brand)
                                                                                                setAmpType(cart.amperage)
                                                                                                setQty1(cart.count)
                                                                                                setBatteryType(cart.batteryType)
                                                                                                setBatteryDescription(cart.batteryDescription)
                                                                                                setIsEdit(true)
                                                                                            }}
                                                                                    ><i className="bi bi-pen "></i>  ویرایش</button>

                                                                                </td>
                                                                            </tr>
                                                                        )
                                                                    })
                                                                }
                                                                </tbody>
                                                            </table>
                                                        }
                                                        {
                                                            batteryQtyDetails?.length > 0 &&
                                                            <ul className='text-small-3 text-muted opacity-75'>
                                                                <li>
                                                                    برای ویرایش هر گزینه روی دکمه ویرایش آن ردیف کلیک کنید و برای حذف در هنگام ویرایش تعداد مورد درخواست را 0 وارد کند
                                                                </li>
                                                            </ul>
                                                        }

                                                    </div>

                                                </div>
                                            </div>
                                        </div>


                                        <div className="col-md-12 mt-4">

                                            <div className="form-floating">
                                    <textarea className="form-control" placeholder="توضیحات" id="floatingTextarea"
                                              value={description}
                                              readOnly={readOnlyStatus}
                                              onChange={
                                                  (event) => {
                                                      setDescription(event.target.value)
                                                  }
                                              }
                                    >

                                    </textarea>
                                                <label htmlFor="floatingTextarea" className="right-0">
                                                    توضیحات سفارش (برای نماینده)
                                                </label>
                                            </div>

                                        </div>

                                        <div className="col-md-12 mt-4">

                                            <div className="form-floating">
                                    <textarea className="form-control" placeholder="توضیحات" id="floatingTextarea"
                                              value={pDescription}
                                              readOnly={readOnlyStatus}
                                              onChange={
                                                  (event) => {
                                                      setPDescription(event.target.value)
                                                  }
                                              }
                                    >

                                    </textarea>
                                                <label htmlFor="floatingTextarea" className="right-0">توضیحات خصوصی (قابل                    مشاهده فقط برای انباردار)</label>
                                            </div>

                                        </div>
                                        <div className="col-12">

                                                <div className="row">
                                                    {
                                                    (order?.last_status?.id === 1 ||  order?.last_status?.id === 13 || order?.last_status?.id === 17 ) &&
                                                    <div className="col-md-5 p-2 mt-5  ">
                                                        <button
                                                            className="btn btn-primary text-center  text-semi-big w-100 p-2 pr-4 "
                                                            onClick={onButtonClick}
                                                            disabled={!isLoaded}
                                                        >
                                                            ویرایش سفارش
                                                        </button>
                                                    </div>
                                                    }
                                                    {
                                                        order?.last_status?.id === 7 &&
                                                    <div className="col-md-4 p-2 mt-5  ">
                                                        <button
                                                            className="btn btn-warning text-center text-semi-big w-100 p-2 pr-4 "
                                                            onClick={
                                                                () => {
                                                                    onStatusButtonClick(17)
                                                                }
                                                            }
                                                            disabled={!isLoaded}
                                                        >
                                                           بازگشت به مرحله انبار
                                                        </button>
                                                    </div>

                                                    }
                                                    {
                                                        order?.last_status?.id === 1 &&
                                                    <div className="col-md-4 p-2 mt-5  ">
                                                        <button
                                                            className="btn btn-success text-center text-semi-big w-100 p-2 pr-4 "
                                                            onClick={
                                                                () => {
                                                                    onStatusButtonClick(13)
                                                                }
                                                            }
                                                            disabled={!isLoaded}
                                                        >
                                                            تایید سفارش
                                                        </button>
                                                    </div>

                                                    }
                                                    {
                                                        order?.last_status?.id === 1 &&
                                                    <div className="col-md-3 p-2 mt-5  ">
                                                        <button
                                                            className="btn btn-danger text-center text-semi-big w-100 p-2 pr-4 "
                                                            onClick={
                                                                () => {
                                                                    onStatusButtonClick(16)
                                                                }
                                                            }
                                                            disabled={!isLoaded}
                                                        >
                                                            لغو سفارش
                                                        </button>
                                                    </div>
                                                    }
                                                    {
                                                        order?.last_status?.id === 13 &&
                                                    <div className="col-md-6 p-2 mt-5  ">
                                                        <button
                                                            className="btn btn-success text-center text-semi-big  p-2 pr-4 px-5 "
                                                            onClick={
                                                                () => {
                                                                    onStatusButtonClick(17)
                                                                }
                                                            }
                                                            disabled={!isLoaded}
                                                        >
                                                            ارسال به انبار جهت بارگیری
                                                        </button>
                                                    </div>
                                                    }
                                                </div>


                                        </div>



                                        <div className="col-12 mt-4">
                                            <div className="card ">
                                                <div className="card-header text-end text-small-2">
                                                   اسناد و فایل ها
                                                </div>
                                                <div className="card-body text-small-2">
                                                    <div className="row">
                                                        <div className="col-md-4 ">
                                                            <label className="custom-file-upload">
                                                                انتخاب فایل
                                                                <input type="file" onChange={onDocChange}
                                                                       accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"
                                                                />
                                                            </label>

                                                            <div className=" text-success text-small-2  bg-light mt-2 p-1 text-center">
                                                                &nbsp;
                                                                {
                                                                    documentFile ?
                                                                        " فایل انتخاب شده : " +
                                                                        documentFile.name
                                                                        : ''
                                                                }
                                                            </div>
                                                        </div>
                                                        <div className="form-floating col-md-4 mt-2">
                                                            <input type="text"
                                                                   className="form-control px-5"
                                                                   id="document_title" name="document_title"
                                                                   placeholder="عنوان فایل"
                                                                   value={documentTitle}
                                                                   onChange={
                                                                       (val) =>  {
                                                                           setDocumentTitle(val.target.value)
                                                                       }
                                                                   }/>
                                                            <label htmlFor="document_title" className="super-small">عنوان
                                                                فایل</label>
                                                        </div>
                                                        <div className="col-md-4 text-left mt-3">
                                                            <button className="btn btn-secondary  w-100"
                                                                    onClick={onUploadClick} >


                                                                آپلود فایل

                                                            </button>
                                                        </div>

                                                    </div>
                                                </div>
                                                <div className="card-footer text-body-secondary">
                                                    {
                                                        order?.documents?.length > 0  &&
                                                        <ul className='text-small-3 text-muted opacity-75'>
                                                            <li>
                                                                لیست فایلها
                                                            </li>
                                                        </ul>
                                                    }


                                                    {
                                                        order?.documents?.map((doc, index) => {
                                                            return (
                                                                <span className="btn btn-dark mx-2 position-relative text-small-2 "
                                                                      key={index}

                                                                      onClick={() => {
                                                                          window.open(doc.path)
                                                                      }}
                                                                >
                                                                {doc.title}

                                                                    <span
                                                                        className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-secondary ">
      {Math.round(doc.file_size / 1000)}K

  </span>
                                                                </span>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    {/*order?.location?.lat > 0 &&*/}
                                    {  isLoaded && false &&


                                    <div className="row maps-container py-2">

                                        <div className="col-12  map-part">
                                            <div className="fw-bold text-muted mb-3 text-small-1">
                                                موقعیت راننده روی نقشه:
                                            </div>

                                            <MapContainer center={[order?.location?.lat, order?.location?.lng]} zoom={13} scrollWheelZoom={false}>
                                                <TileLayer
                                                    attribution='&copy; <a href="https://www.idmt.ir">IDMT </a> contributors'
                                                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                                />
                                                <Marker position={[order?.location?.lat, order?.location?.lng]}>
                                                    <Popup>
                                                       تاریخ:
                                                        &nbsp;
                                                        {
                                                            order?.location?.date
                                                        }
                                                    </Popup>
                                                </Marker>
                                            </MapContainer>
                                        </div>
                                    </div>
                                    }
                                </div>
                            </div>

                        </div>
                        <div className="col-lg-12">

                            <div className="card">
                                <div className="card-body">
                                    <h5 className="card-title">تاریخچه وضعیت های سفارش</h5>
                                    <div className="row">
                                        {
                                            order?.history?.map(stat => {
                                                return (
                                                    <div className='col-12 mt-2 bg-light text-small-1  p-2'>
                                                        <IoMdCheckmarkCircleOutline className='mx-2'
                                                                                    style={{color:stat.status.color }}
                                                        />
                                                        سفارش در تاریخ:
                                                        &nbsp;
                                                        {stat.date}
                                                        &nbsp;
                                                        توسط
                                                        &nbsp;
                                                        {stat.user.name}
                                                        &nbsp;
                                                        {stat.user.surname}
                                                        &nbsp;
                                                        در وضعیت
                                                        &nbsp;
                                                        <span className='fw-bold' style={{color:stat.status.color }}>
                                                            {stat.status.title}
                                                        </span>

                                                        &nbsp;
                                                        قرار گرفت.

                                                        <div className='fw-bold text-muted me-4 text-small-2 mt-3'>
                                                            {stat.description?.length > 2 ? stat.description : ''}
                                                        </div>
                                                    </div>
                                                )

                                            })

                                        }
                                    </div>

                                </div>
                            </div>

                        </div>

                    </div>
                </section>

            </main>

        </React.Fragment>
    );
}

export default OrderDetails;